"use client"

import CartDropdown from "../cart-dropdown"
import { HttpTypes } from "@medusajs/types"
import { useEffect, useRef, useState } from "react"

type CartDropdownWrapperProps = {
  cart: HttpTypes.StoreCart | null
}

const CartDropdownWrapper = ({ cart }: CartDropdownWrapperProps) => {
  const wrapperRef = useRef<HTMLDivElement>(null)

  // Remove border-bottom from the cart dropdown link
  useEffect(() => {
    if (wrapperRef.current) {
      const linkElement = wrapperRef.current.querySelector('a')
      if (linkElement) {
        linkElement.classList.remove('border-b-4')
        linkElement.classList.remove('border-white')
      }
    }
  }, [])

  // Create refs for mouse events
  const [isHovered, setIsHovered] = useState(false)

  // Handle mouse events
  const handleMouseEnter = () => {
    setIsHovered(true)
  }

  const handleMouseLeave = () => {
    setIsHovered(false)
  }

  return (
    <div
      className="h-full w-full flex items-center"
      ref={wrapperRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="h-full w-full relative">
        {/* Create an overlay div that covers the entire area */}
        <div
          className={`absolute inset-0 z-10 ${isHovered ? 'pointer-events-none' : ''}`}
          onMouseEnter={handleMouseEnter}
        />
        <CartDropdown cart={cart} isForceOpen={isHovered} />
      </div>
    </div>
  )
}

export default CartDropdownWrapper
